import { z } from "zod/v4";

export const CustomEventPageViewSettingsDtoSchema = z.object({});

export type CustomEventPageViewSettingsDto = z.infer<
  typeof CustomEventPageViewSettingsDtoSchema
>;

export const CustomEventProductPageViewSettingsDtoSchema = z.array(
  z.object({
    productId: z.string(),
    handle: z.string(),
  })
);

export type CustomEventProductPageViewSettingsDto = z.infer<
  typeof CustomEventProductPageViewSettingsDtoSchema
>;

export const CustomEventCollectionPageViewSettingsDtoSchema = z.array(
  z.object({
    handle: z.string(),
  })
);

export type CustomEventCollectionPageViewSettingsDto = z.infer<
  typeof CustomEventCollectionPageViewSettingsDtoSchema
>;

export const CustomEventClickEventSettingsDtoSchema = z.object({
  selectors: z.string().array(),
});

export type CustomEventClickEventSettingsDto = z.infer<
  typeof CustomEventClickEventSettingsDtoSchema
>;

export const CustomEventElementViewedSettingsDtoSchema = z.object({
  selectors: z.string().array(),
});

export type CustomEventElementViewedSettingsDto = z.infer<
  typeof CustomEventElementViewedSettingsDtoSchema
>;

export const CustomEventScrollDepthSettingsDtoSchema = z.object({
  mobile: z.object({ percentage: z.number() }),
  desktop: z.object({ percentage: z.number() }),
});

export type CustomEventScrollDepthSettingsDto = z.infer<
  typeof CustomEventScrollDepthSettingsDtoSchema
>;

export const CustomEventJavascriptSettingsDtoSchema = z.object({
  code: z.string(),
});

export type CustomEventJavascriptSettingsDto = z.infer<
  typeof CustomEventJavascriptSettingsDtoSchema
>;

export const CustomEventJavascriptImportedSettingsDtoSchema = z.object({
  registered: z.boolean(),
});

export const CustomEventAddToCartSettingsDtoSchema = z.object({});

export type CustomEventAddToCartSettingsDto = z.infer<
  typeof CustomEventAddToCartSettingsDtoSchema
>;

export const CustomEventBeginCheckoutSettingsDtoSchema = z.object({});

export type CustomEventBeginCheckoutSettingsDto = z.infer<
  typeof CustomEventBeginCheckoutSettingsDtoSchema
>;

export const CustomEventOrderPlacedSettingsDtoSchema = z.object({});

export type CustomEventOrderPlacedSettingsDto = z.infer<
  typeof CustomEventOrderPlacedSettingsDtoSchema
>;

export const CustomEventVisitedAnyPdpSettingsDtoSchema = z.object({});

export type CustomEventVisitedAnyPdpSettingsDto = z.infer<
  typeof CustomEventVisitedAnyPdpSettingsDtoSchema
>;

export const CustomEventVisitedAnyCollectionSettingsDtoSchema = z.object({});

export type CustomEventVisitedAnyCollectionSettingsDto = z.infer<
  typeof CustomEventVisitedAnyCollectionSettingsDtoSchema
>;
